import React, { useState, useRef } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import ConnectionMeetingForm from './ConnectionMeetingForm';

const ConnectionMeetingDropdown = props => {
  const [isOpen, setIsOpen] = useState(false);
  const [modal, setModal] = useState(false);
  const dropdownRef = useRef(null);

  const toggleModal = () => {
    setModal(!modal);
    setIsOpen(false); // Close dropdown when modal toggles
  };

  const handleLetsMeetClick = e => {
    e.stopPropagation();
    setModal(true);
    setIsOpen(false); // Close dropdown when opening modal
  };

  const toggleDropdown = e => {
    e.preventDefault();
    setIsOpen(!isOpen);
  };

  return (
    <div ref={dropdownRef}>
      <Dropdown
        isOpen={isOpen}
        toggle={toggleDropdown}
        // Add these props to control dropdown behavior
        inNavbar
        direction="down"
      >
        <DropdownToggle tag="div" className="dropdown-toggle">
          <FontAwesomeIcon icon={faEllipsisV} />
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem onClick={handleLetsMeetClick}>Lets Meet</DropdownItem>
        </DropdownMenu>
      </Dropdown>

      <Modal className="meeting-box" isOpen={modal} toggle={toggleModal} backdrop="static">
        <ModalHeader toggle={toggleModal}>Meeting Form</ModalHeader>
        <ModalBody>
          <ConnectionMeetingForm connections={props.connection} />
        </ModalBody>
      </Modal>
    </div>
  );
};

export default ConnectionMeetingDropdown;
